module.exports = "<form>\r\n  <spk-card [class]=\"'col-md-8'\" title=\"Search Examples\">\r\n    <spk-search-grid #grid defaultSortProperty=\"Id DESC\" list=\"ExampleSearchRow\" [leftLinks]=\"leftLinks\" [headerLinks]=\"headerLinks\" [rightLinks]=\"rightLinks\"></spk-search-grid>\r\n  </spk-card>\r\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/full-crud-example/examples/examples.component.html
// module id = ./src/app/components/examples/full-crud-example/examples/examples.component.html
// module chunks = main